var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 1.89124V5.33336C11.6666 5.80006 11.6666 6.03342 11.7574 6.21168C11.8373 6.36848 11.9648 6.49596 12.1216 6.57586C12.2999 6.66669 12.5332 6.66669 12.9999 6.66669H16.442M16.6666 8.32354V14.3334C16.6666 15.7335 16.6666 16.4336 16.3941 16.9683C16.1544 17.4387 15.772 17.8212 15.3016 18.0609C14.7668 18.3334 14.0667 18.3334 12.6666 18.3334H7.33325C5.93312 18.3334 5.23306 18.3334 4.69828 18.0609C4.22787 17.8212 3.84542 17.4387 3.60574 16.9683C3.33325 16.4336 3.33325 15.7335 3.33325 14.3334V5.66669C3.33325 4.26656 3.33325 3.56649 3.60574 3.03171C3.84542 2.56131 4.22787 2.17885 4.69828 1.93917C5.23306 1.66669 5.93312 1.66669 7.33325 1.66669H10.0097C10.6212 1.66669 10.9269 1.66669 11.2147 1.73576C11.4698 1.797 11.7136 1.89801 11.9373 2.03509C12.1896 2.18969 12.4058 2.40588 12.8382 2.83826L15.495 5.49511C15.9274 5.92749 16.1436 6.14368 16.2982 6.39597C16.4353 6.61966 16.5363 6.86352 16.5975 7.11861C16.6666 7.40633 16.6666 7.71206 16.6666 8.32354Z",
    stroke: "#F7FAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.32917ed39d0eacc40a190ae7c4159a2a.svg";
export { ForwardRef as ReactComponent };